import React from 'react';
import DatePicker from 'react-datepicker';
import calendarIcon from '../../../assets/images/calendar_icon.png';
import 'react-datepicker/dist/react-datepicker.css';

const CustomDatePicker = ({
    label,
    value = null,
    onChange,
    minDate,
    maxDate,
    required = false,
    placeholder = "MM/DD/YYYY",
    className = "custom-input datepicker"
}) => {
    // Handles the date change and formats it as 'MM-DD-YYYY' to match your form
    const handleDateChange = (date) => {
        if (date) {
            // Format as MM-DD-YYYY to match your existing form format
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const year = date.getFullYear();
            const formattedDate = `${month}-${day}-${year}`;
            onChange(formattedDate);
        } else {
            onChange(null);
        }
    };

    // Parse the string value back to Date object for the DatePicker
    const parseValue = (dateString) => {
        if (!dateString) return null;
        try {
            // Parse MM-DD-YYYY format
            const [month, day, year] = dateString.split('-');
            if (month && day && year) {
                return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
            }
            return null;
        } catch (error) {
            return null;
        }
    };

    // Set default min and max dates if not provided
    const defaultMinDate = minDate || (() => {
        const date = new Date();
        date.setFullYear(date.getFullYear() - 100);
        return date;
    })();
    
    const defaultMaxDate = maxDate || (() => {
        const date = new Date();
        date.setFullYear(date.getFullYear() - 18); // Restrict to minimum 18 years old by default
        return date;
    })();

    return (
        <div className="custom-date-picker">
            {label && (
                <label className="date-label">
                    {label} {required && <span className="required">*</span>}
                </label>
            )}
            <div className="date-picker-wrapper">
                <DatePicker
                    selected={parseValue(value)}
                    onChange={handleDateChange}
                    dateFormat="MM-dd-yyyy"
                    minDate={defaultMinDate}
                    maxDate={defaultMaxDate}
                    placeholderText={placeholder}
                    className={className}
                    required={required}
                    showPopperArrow={false}
                    showMonthDropdown
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={100}
                    // Add validation to prevent future dates and dates over 100 years ago
                    // Use the provided maxDate or default to 18 years ago
                    filterDate={(date) => {
                        const hundredYearsAgo = new Date();
                        hundredYearsAgo.setFullYear(new Date().getFullYear() - 100);
                        return date <= defaultMaxDate && date >= hundredYearsAgo;
                    }}
                    // Ensure we show the month view by default
                    dropdownMode="select"
                    popperClassName="custom-datepicker-popper"
                    popperPlacement="bottom-start"
                    // Force calendar view (month/day) instead of year picker
                    showMonthYearPicker={false}
                    showYearPicker={false}
                    showMonthPicker={false}
                    showQuarterPicker={false}
                    showWeekPicker={false}
                    showTimeSelect={false}
                    showTimeSelectOnly={false}
                    showTimeInput={false}
                    // Additional props to ensure calendar view
                    calendarStartDay={1}
                    showDisabledMonthNavigation={false}
                    showPreviousMonths={true}
                    showNextMonthButton={true}
                    showPreviousMonthButton={true}
                />
               <span className="date-picker-icon"><img src={calendarIcon} alt="calendar" /></span>
            </div>
        </div>
    );
};

export default CustomDatePicker;
